import React, { useState, useEffect } from 'react'
import Helmet from 'react-helmet'

const ReviewsSchema = (props) => {
  const [reviewsSchema, setreviewsSchema] = useState({})

  useEffect(() => {
    const reviewsSchemaBuild = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Twisted Road Motorcycle Rental',
      brand: { '@type': 'Thing', name: 'Twisted Road' },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue:
          props.ratingValue === 0
            ? 1
            : props.ratingValue,
        ratingCount:
          props.ratingCount === 0
            ? 1
            : props.ratingCount,
      },
    }
    setreviewsSchema(reviewsSchemaBuild)
  }, [props.ratingValue])

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(reviewsSchema)}
      </script>
    </Helmet>
  )
}

export default ReviewsSchema

ReviewsSchema.defaultProps = {
  ratingValue: 1,
  ratingCount: 1,
  url: 'https://www.twistedroad.com',
}
